/**
 * Business Store
 * Manages selected business state and persistence
 */

import { create } from "zustand";
import { persist, devtools } from "zustand/middleware";

const useBusinessStore = create(
  devtools(
    persist(
      (set, get) => ({
        // State
        selectedBusiness: null,
        businessList: [],

        // Actions
        setSelectedBusiness: (business) => {
          set({ selectedBusiness: business });
        },

        setBusinessList: (businesses) => {
          set({ businessList: businesses });

          // Auto-select first business if none selected and businesses available
          const { selectedBusiness } = get();
          if (!selectedBusiness && businesses && businesses.length > 0) {
            set({ selectedBusiness: businesses[0] });
          }
        },

        clearBusinesses: () => {
          set({ selectedBusiness: null, businessList: [] });
          if (typeof window !== "undefined") {
            localStorage.removeItem("business-storage");
          }
        },

        // Getters
        getSelectedBusiness: () => get().selectedBusiness,
        getBusinessList: () => get().businessList,

        // Check if we have businesses
        hasBusinesses: () => {
          const { businessList } = get();
          return businessList && businessList.length > 0;
        },

        // Get business by ID
        getBusinessById: (id) => {
          const { businessList } = get();
          return businessList.find((business) => business.id === id);
        },
      }),
      {
        name: "business-storage",
        // Only persist selected business, not the full list (which comes from API)
        partialize: (state) => ({ selectedBusiness: state.selectedBusiness }),
      },
    ),
    {
      name: "business-store",
    },
  ),
);

export { useBusinessStore };
